import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button } from 'react-bootstrap';
import rest from 'rest';

import { REST_API_URL, APP_PATH, PERMISSION_READ } from "../../Utils/Global";
import { cloneObject } from "../../Utils/Utils";

import PermissionCheck from '../Permissions/PermissionCheck';

import ControlledGrid from '../Helper/ControlledGrid';
import Status from '../Helper/Status';

import AbstractEntity from '../Entity/AbstractEntity';
import Contact from '../Entity/Contact';

/**
* Class Financeur
* Financeur view component
**/
class Financeur extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * data.object : instance data
  **/

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "Financeur";
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.state.object === undefined) {
        return <div></div>;
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    const historyBack = <Button bsStyle="link" onClick={this.props.modal ? this.props.closeModal : this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Rendering the view
		return (
      <div>
        {/* Status information */}
        {status}
        {historyBack}
  			<Form horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire de financeur.</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idFinanceur" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={2}><FormControl type="text" value={this.getObjectProperty("idFinanceur")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup controlId="libelleFinanceur">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Libellé</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("libelleFinanceur")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="commentaire">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Commentaire</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl onChange={this.handleChange} componentClass="textarea" rows="5" value={this.getObjectProperty("commentaire")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* Contact ManyToMany */}
          <PermissionCheck component={Contact.getClassName()} permission={PERMISSION_READ}>
            <FormGroup controlId="contacts" style={{ display: 'none' }}>
            <Col componentClass={ControlLabel} sm={2}>Contacts</Col>
            <Col sm={6}>
              <ControlledGrid ref="contactsGrid" path="contacts" objectPath={"financeurs_contacts/" + this.getObjectProperty(this.getIdField()) + "/contacts"} objectClass={Contact}
              mode={this.state.mode} cbxUrl={REST_API_URL + "financeurs_contacts/" + this.getObjectProperty(this.getIdField()) + "/contacts/inverse/"}
              optionValueKey="idContact" optionLabelKey="fullName" />
            </Col>
            </FormGroup>
          </PermissionCheck>

          {/* Submit button */}
          {this.state.mode !== "readonly" ?
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" type="submit">Sauvegarder</Button>
              </Col>
            </FormGroup> : ""
          }
  			</Form>
      </div>
		);
	}

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idFinanceur";
  }

  /**
  * sendFormData
  * Saves the data
  **/
  sendFormData () {
    let method;
    const path = REST_API_URL + this.getObjectPath();
    let financeurObj = cloneObject(this.state.object);

    console.log(this.state.mode);
    if(this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
      if(this.refs.contactsGrid !== undefined) financeurObj.contacts = this.refs.contactsGrid.getArrayToSave();
    }

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(financeurObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.saveGrids();
        this.setState({
          status: {
            type: 'success',
            message: 'Donneur d\'ordre sauvegardé.'
          },
          object: JSON.parse(response.entity)
        });
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);

        const state = {
          status: {
            type: 'success',
            message: 'Financeur créé.'
          },
          mode: 'edit',
          object: newObj
        };

        this.replaceHistory(APP_PATH + "/financeurs/" + newObj[this.getIdField()] + "/edit", state);

        if(this.props.onAdd) {
          this.props.onAdd.call(this, newObj);
        }
      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

  /**
  * saveGrids
  * Saves the ManyToMany components
  **/
  saveGrids() {
    if(this.refs.contactsGrid !== undefined) this.refs.contactsGrid.saveAll();
  }

}
export default Financeur;



// WEBPACK FOOTER //
// ./src/views/Entity/Financeur.js